// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import dutyRosterService from "../../../Services/dutyrosterService";
// import staffService from "../../../Services/staffService";
// import roleService from "../../../Services/roleService";

// const SHIFT_DEFAULTS = {
//   morning: { start_time: "08:00", end_time: "16:00" },
//   evening: { start_time: "16:00", end_time: "00:00" },
//   night:   { start_time: "00:00", end_time: "08:00" },
// };

// const Field = ({ label, children }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[12px] font-[500] text-gray-500">{label}</label>
//     {children}
//   </div>
// );

// const inputCls =
//   "w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100";

// export default function EditDuty() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form, setForm]       = useState({ staff_id: "", role_id: "", shift: "morning", start_time: "08:00", end_time: "16:00", duty_date: "", notes: "" });
//   const [staffList, setStaff] = useState([]);
//   const [roleList, setRoles]  = useState([]);
//   const [saving, setSaving]   = useState(false);
//   const [deleting, setDel]    = useState(false);
//   const [error, setError]     = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     Promise.all([
//       dutyRosterService.fetchById(id),
//       staffService.fetchAll().catch(() => ({ staff: [] })),
//       roleService.fetchAllRoles().catch(() => ({ roles: [] })),
//     ]).then(([dutyRes, staffRes, rolesRes]) => {
//       const d = dutyRes.duty;
//       setForm({
//         staff_id:   d.staff_id,
//         role_id:    d.role_id,
//         shift:      d.shift,
//         start_time: d.start_time?.slice(0, 5) || SHIFT_DEFAULTS[d.shift]?.start_time || "08:00",
//         end_time:   d.end_time?.slice(0, 5) || SHIFT_DEFAULTS[d.shift]?.end_time || "16:00",
//         duty_date:  d.duty_date?.slice(0, 10),
//         notes:      d.notes || "",
//       });
//       const staffArr = staffRes?.staff || staffRes?.staffs || staffRes?.data || (Array.isArray(staffRes) ? staffRes : []);
//       const roleArr  = rolesRes?.roles || rolesRes?.data || (Array.isArray(rolesRes) ? rolesRes : []);
//       setStaff(Array.isArray(staffArr) ? staffArr : []);
//       setRoles(Array.isArray(roleArr) ? roleArr : []);
//       setLoading(false);
//     }).catch(() => {
//       setError("Failed to load duty details.");
//       setLoading(false);
//     });
//   }, [id]);

//   const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

//   const handleShiftChange = (shift) => {
//     setForm((p) => ({
//       ...p,
//       shift,
//       start_time: SHIFT_DEFAULTS[shift]?.start_time ?? p.start_time,
//       end_time: SHIFT_DEFAULTS[shift]?.end_time ?? p.end_time,
//     }));
//   };

//   const handleUpdate = async () => {
//     if (!form.staff_id || !form.role_id || !form.duty_date) {
//       setError("Staff, Role, and Date are required.");
//       return;
//     }
//     setSaving(true);
//     setError("");
//     try {
//       await dutyRosterService.update(id, form);
//       navigate("/duty-roster");
//     } catch (e) {
//       setError(e?.message || "Error updating duty.");
//     }
//     setSaving(false);
//   };

//   const handleDelete = async () => {
//     if (!window.confirm("Are you sure you want to delete this duty?")) return;
//     setDel(true);
//     try {
//       await dutyRosterService.delete(id);
//       navigate("/duty-roster");
//     } catch {
//       setError("Error deleting duty.");
//       setDel(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="bg-gray-50 flex items-center justify-center py-20 px-3">
//         <p className="text-[13px] text-gray-400">Loading duty details...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-50 flex items-start justify-center py-4 sm:py-6 md:py-10 px-3 sm:px-4">
//       <div className="w-full max-w-8xl">
//         <div className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
//           <div className="bg-[#215187] px-4 sm:px-6 md:px-8 py-4 sm:py-5 flex items-center gap-3">
//             <div>
//               <h1 className="text-white text-[15px] sm:text-[17px] md:text-[18px] font-[500] tracking-tight">
//                 Edit Duty
//               </h1>
//               <p className="text-gray-300 text-[11px] sm:text-[12px] mt-0.5">
//                 Update duty assignment details
//               </p>
//             </div>
//           </div>

//           <div className="px-4 sm:px-6 md:px-8 py-4 sm:py-6">
//             {error && (
//               <div className="mb-4 bg-red-50 text-red-600 border border-red-200 rounded-lg px-3.5 py-2.5 text-[13px]">
//                 {error}
//               </div>
//             )}

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
//               <Field label="Staff Member *">
//                 <select value={form.staff_id} onChange={(e) => f("staff_id", e.target.value)} className={inputCls}>
//                   <option value="">Select Staff</option>
//                   {staffList.map((s) => <option key={s.staff_id} value={s.staff_id}>{s.full_name}</option>)}
//                 </select>
//               </Field>
//               <Field label="Role *">
//                 <select value={form.role_id} onChange={(e) => f("role_id", e.target.value)} className={inputCls}>
//                   <option value="">Select Role</option>
//                   {roleList.map((r) => <option key={r.role_id} value={r.role_id}>{r.role_name}</option>)}
//                 </select>
//               </Field>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4">
//               <Field label="Shift *">
//                 <select value={form.shift} onChange={(e) => handleShiftChange(e.target.value)} className={inputCls}>
//                   <option value="morning">Morning</option>
//                   <option value="evening">Evening</option>
//                   <option value="night">Night</option>
//                 </select>
//               </Field>
//               <Field label="Duty Date *">
//                 <input type="date" value={form.duty_date} onChange={(e) => f("duty_date", e.target.value)} className={inputCls} />
//               </Field>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4">
//               <Field label="Start Time *">
//                 <input type="time" value={form.start_time} onChange={(e) => f("start_time", e.target.value)} className={inputCls} />
//               </Field>
//               <Field label="End Time *">
//                 <input type="time" value={form.end_time} onChange={(e) => f("end_time", e.target.value)} className={inputCls} />
//               </Field>
//             </div>

//             <div className="mt-3 sm:mt-4">
//               <Field label="Notes (Optional)">
//                 <input
//                   placeholder="e.g. ICU duty, emergency cover..."
//                   value={form.notes}
//                   onChange={(e) => f("notes", e.target.value)}
//                   className={inputCls}
//                 />
//               </Field>
//             </div>

//             <div className="border-t border-gray-100 mt-6 sm:mt-8 pt-4 sm:pt-6 flex items-center justify-between">
//               <button
//                 type="button"
//                 onClick={handleDelete}
//                 disabled={deleting}
//                 className="text-[13px] text-red-500 hover:text-red-700 transition-colors font-[500] disabled:opacity-60"
//               >
//                 {deleting ? "Deleting..." : "Delete Duty"}
//               </button>
//               <div className="flex items-center gap-4">
//                 <button
//                   type="button"
//                   onClick={() => navigate("/duty-roster")}
//                   className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
//                 >
//                   ← Cancel
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleUpdate}
//                   disabled={saving}
//                   className="bg-[#2F6DB4] hover:bg-[#255A8C] transition-colors text-white text-[13px] font-[500] px-5 sm:px-6 py-2 sm:py-2.5 rounded-lg disabled:opacity-60"
//                 >
//                   {saving ? "Saving..." : "Save Changes"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dutyRosterService from "../../../Services/dutyrosterService";
import staffService from "../../../Services/staffService";
import roleService from "../../../Services/roleService";
import doctorService from "../../../Services/doctorService";

const SHIFT_DEFAULTS = {
  morning: { start_time: "08:00", end_time: "16:00" },
  evening: { start_time: "16:00", end_time: "00:00" },
  night:   { start_time: "00:00", end_time: "08:00" },
};

const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    {children}
  </div>
);

const inputCls =
  "w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-blue-200 focus:border-blue-300 focus:ring-2 focus:ring-blue-100";

// Normalizes whatever the API sends for a date column into a plain
// 'YYYY-MM-DD' string, without letting JS Date do a UTC conversion
// (which shifts the day depending on the server/browser timezone).
const toDateInputValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  // Fallback: value came through as a Date object (e.g. mysql2 without
  // dateStrings). Use local getters, not toISOString(), to avoid the
  // UTC shift that causes the "date is off by one" bug.
  const d = new Date(value);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// Normalizes a TIME column ('HH:MM:SS' or 'HH:MM') to 'HH:MM' for <input type="time">
const toTimeInputValue = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "string") return value.slice(0, 5);
  return fallback;
};

export default function EditDuty() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm]          = useState({
    assigned_to: "staff", staff_id: "", doctor_id: "", role_id: "",
    shift: "morning", start_time: "08:00", end_time: "16:00", duty_date: "", notes: "",
  });
  const [staffList, setStaff]    = useState([]);
  const [roleList, setRoles]     = useState([]);
  const [doctorList, setDoctors] = useState([]);
  const [saving, setSaving]      = useState(false);
  const [deleting, setDel]       = useState(false);
  const [error, setError]        = useState("");
  const [loading, setLoading]    = useState(true);

  useEffect(() => {
    Promise.all([
      dutyRosterService.fetchById(id),
      staffService.fetchAll().catch(() => ({})),
      roleService.fetchAllRoles().catch(() => ({})),
      doctorService.fetchAllDoctors().catch(() => ({})),
    ]).then(([dutyRes, staffRes, rolesRes, doctorsRes]) => {
      const d = dutyRes.duty;
      setForm({
        assigned_to: d.assigned_to || "staff",
        staff_id:    d.staff_id  || "",
        doctor_id:   d.doctor_id || "",
        role_id:     d.role_id || "",
        shift:       d.shift,
        start_time:  toTimeInputValue(d.start_time, SHIFT_DEFAULTS[d.shift]?.start_time || "08:00"),
        end_time:    toTimeInputValue(d.end_time,   SHIFT_DEFAULTS[d.shift]?.end_time   || "16:00"),
        duty_date:   toDateInputValue(d.duty_date),
        notes:       d.notes || "",
      });

      const staffArr   = staffRes?.staff   || staffRes?.staffs  || (Array.isArray(staffRes)   ? staffRes   : []);
      const roleArr    = rolesRes?.roles   || (Array.isArray(rolesRes)   ? rolesRes   : []);
      const doctorArr  = doctorsRes?.doctors || (Array.isArray(doctorsRes) ? doctorsRes : []);

      setStaff(Array.isArray(staffArr)  ? staffArr  : []);
      setRoles(Array.isArray(roleArr)   ? roleArr   : []);
      setDoctors(Array.isArray(doctorArr) ? doctorArr : []);
      setLoading(false);
    }).catch(() => {
      setError("Failed to load duty details.");
      setLoading(false);
    });
  }, [id]);

  const f = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleAssignedToChange = (type) => {
    setForm((p) => ({
      ...p,
      assigned_to: type,
      staff_id: "",
      doctor_id: "",
      role_id: "",
    }));
  };

  const handleShiftChange = (shift) => {
    setForm((p) => ({
      ...p,
      shift,
      start_time: SHIFT_DEFAULTS[shift]?.start_time ?? p.start_time,
      end_time:   SHIFT_DEFAULTS[shift]?.end_time   ?? p.end_time,
    }));
  };

  const handleUpdate = async () => {
    if (form.assigned_to === "staff" && !form.staff_id) {
      setError("Please select a staff member."); return;
    }
    if (form.assigned_to === "doctor" && !form.doctor_id) {
      setError("Please select a doctor."); return;
    }
    if (!form.duty_date) {
      setError("Duty date is required."); return;
    }
    setSaving(true);
    setError("");
    // Note: for doctor duties, the backend model always forces role_id to
    // NULL regardless of what's sent here — we don't need to resolve a
    // "doctor" role_id on the frontend anymore.
    const payload = {
      ...form,
      role_id:   form.assigned_to === "doctor" ? null : form.role_id,
      staff_id:  form.assigned_to === "staff"  ? form.staff_id  : null,
      doctor_id: form.assigned_to === "doctor" ? form.doctor_id : null,
    };
    try {
      await dutyRosterService.update(id, payload);
      navigate("/duty-roster");
    } catch (e) {
      setError(e?.message || "Error updating duty.");
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this duty?")) return;
    setDel(true);
    try {
      await dutyRosterService.delete(id);
      navigate("/duty-roster");
    } catch {
      setError("Error deleting duty.");
      setDel(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-gray-50 flex items-center justify-center py-20 px-3">
        <p className="text-[13px] text-gray-400">Loading duty details...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 flex items-start justify-center py-4 sm:py-6 md:py-10 px-3 sm:px-4">
      <div className="w-full max-w-8xl">
        <div className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* Header */}
          <div className="bg-[#215187] px-4 sm:px-6 md:px-8 py-4 sm:py-5">
            <h1 className="text-white text-[15px] sm:text-[17px] md:text-[18px] font-[500] tracking-tight">
              Edit Duty
            </h1>
            <p className="text-gray-300 text-[11px] sm:text-[12px] mt-0.5">
              Update duty assignment details
            </p>
          </div>

          <div className="px-4 sm:px-6 md:px-8 py-4 sm:py-6">
            {error && (
              <div className="mb-4 bg-red-50 text-red-600 border border-red-200 rounded-lg px-3.5 py-2.5 text-[13px]">
                {error}
              </div>
            )}

            {/* ── Assign To Toggle ── */}
            <div className="mb-5">
              <label className="text-[12px] font-[500] text-gray-500 mb-2 block">Assign To *</label>
              <div className="flex bg-gray-100 rounded-lg p-[3px] w-fit">
                <button
                  type="button"
                  onClick={() => handleAssignedToChange("staff")}
                  className={`px-6 py-2 text-[13px] font-[500] rounded-md transition-colors ${
                    form.assigned_to === "staff"
                      ? "bg-white text-[#215187] shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Staff
                </button>
                <button
                  type="button"
                  onClick={() => handleAssignedToChange("doctor")}
                  className={`px-6 py-2 text-[13px] font-[500] rounded-md transition-colors ${
                    form.assigned_to === "doctor"
                      ? "bg-white text-[#215187] shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Doctor
                </button>
              </div>
            </div>

            {/* ── Staff Fields ── */}
            {form.assigned_to === "staff" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
                <Field label="Staff Member *">
                  <select value={form.staff_id} onChange={(e) => f("staff_id", e.target.value)} className={inputCls}>
                    <option value="">Select Staff</option>
                    {staffList.map((s) => (
                      <option key={s.staff_id} value={s.staff_id}>{s.full_name}</option>
                    ))}
                  </select>
                </Field>
                <Field label="Role *">
                  <select value={form.role_id} onChange={(e) => f("role_id", e.target.value)} className={inputCls}>
                    <option value="">Select Role</option>
                    {roleList.map((r) => (
                      <option key={r.role_id} value={r.role_id}>{r.role_name}</option>
                    ))}
                  </select>
                </Field>
              </div>
            )}

            {/* ── Doctor Fields ── */}
            {form.assigned_to === "doctor" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
                <Field label="Doctor *">
                  <select value={form.doctor_id} onChange={(e) => f("doctor_id", e.target.value)} className={inputCls}>
                    <option value="">Select Doctor</option>
                    {doctorList.map((d) => (
                      <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                  </select>
                </Field>
                <Field label="Role">
                  <input
                    value="Doctor"
                    readOnly
                    className="w-full px-3 py-2 text-[13px] text-gray-500 bg-gray-50 border border-gray-200 rounded-lg outline-none cursor-not-allowed"
                  />
                </Field>
              </div>
            )}

            {/* ── Shift & Date ── */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <Field label="Shift *">
                <select value={form.shift} onChange={(e) => handleShiftChange(e.target.value)} className={inputCls}>
                  <option value="morning">Morning</option>
                  <option value="evening">Evening</option>
                  <option value="night">Night</option>
                </select>
              </Field>
              <Field label="Duty Date *">
                <input type="date" value={form.duty_date} onChange={(e) => f("duty_date", e.target.value)} className={inputCls} />
              </Field>
            </div>

            {/* ── Times ── */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4">
              <Field label="Start Time *">
                <input type="time" value={form.start_time} onChange={(e) => f("start_time", e.target.value)} className={inputCls} />
              </Field>
              <Field label="End Time *">
                <input type="time" value={form.end_time} onChange={(e) => f("end_time", e.target.value)} className={inputCls} />
              </Field>
            </div>

            {/* ── Notes ── */}
            <div className="mt-3 sm:mt-4">
              <Field label="Notes (Optional)">
                <input
                  placeholder="e.g. ICU duty, emergency cover..."
                  value={form.notes}
                  onChange={(e) => f("notes", e.target.value)}
                  className={inputCls}
                />
              </Field>
            </div>

            {/* ── Actions ── */}
            <div className="border-t border-gray-100 mt-6 sm:mt-8 pt-4 sm:pt-6 flex items-center justify-between">
              <button
                type="button"
                onClick={handleDelete}
                disabled={deleting}
                className="text-[13px] text-red-500 hover:text-red-700 transition-colors font-[500] disabled:opacity-60"
              >
                {deleting ? "Deleting..." : "Delete Duty"}
              </button>
              <div className="flex items-center gap-4">
                <button
                  type="button"
                  onClick={() => navigate("/duty-roster")}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="button"
                  onClick={handleUpdate}
                  disabled={saving}
                  className="bg-[#2F6DB4] hover:bg-[#255A8C] transition-colors text-white text-[13px] font-[500] px-5 sm:px-6 py-2 sm:py-2.5 rounded-lg disabled:opacity-60"
                >
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}